import type { IconProps } from "./icon-types";

/**
 * 삼각형 안 정립 "!" — warning/주의 상태 표시(stem 위 · dot 아래로 정보 "i"와 위아래 반대).
 * Toast warning tone 등 status 표현에서 공용.
 */
export const WarningIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 2.4 14.4 13.4H1.6Z" />
    <path d="M8 6.6v2.9" />
    <circle cx="8" cy="11.4" r="0.85" fill="currentColor" stroke="none" />
  </svg>
);
